export interface ProgressIndicatorProps {
  animated?: boolean
  className?: string
  progress: number
  rtl?: boolean
  size?: ProgressIndicatorSize
  style?: ProgressIndicatorStyle
}

export enum ProgressIndicatorStyle {
  positive = 'positive',
  warning = 'warning',
  critical = 'critical',
}

export enum ProgressIndicatorSize {
  medium = 'm',
  large = 'l',
}

export type ProgressIndicatorStyleType = `${ProgressIndicatorStyle}`
export type ProgressIndicatorSizeType = `${ProgressIndicatorSize}`
